import { BaseRouteService } from 'core/services';

class ItemSubcategoryRouteService extends BaseRouteService {
    constructor() {
        super('item-subcategories');
    }
   
    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,productId,subCategoryId,isActive,unitOfMeasureIdToExclude}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }
    
    create(resource) {
        return super.create(this.base, resource);
    }

	batchUpdate(resource) {
		return super.batchUpdate(`${this.base}/batch`, resource);
	}

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,sort,itemCategoryId,itemId,itemName,procedureCodeId,inActive,showPumps}', filter);    
    }

    upload(resource){
        return super.create(this.base + '/upload', resource);
    }
}

export default ItemSubcategoryRouteService;
